/**
 *
 * @param templatePart graphql nodeByUri layout fieldas
 * @returns [elementorData,elementorCssHref,elementorTemplateId]
 */
export function getElementorTemplateProps(templatePart) {
    var _a, _b;
    if (!(templatePart === null || templatePart === void 0 ? void 0 : templatePart.id))
        return [];
    const templateData = JSON.parse((templatePart === null || templatePart === void 0 ? void 0 : templatePart.elementorData) || '[]');
    const templateId = templatePart.id || null;
    const templateDatabaseId = templatePart.databaseId || null;
    const templateCss = ((_b = (_a = templatePart === null || templatePart === void 0 ? void 0 : templatePart.css) === null || _a === void 0 ? void 0 : _a.at(0)) === null || _b === void 0 ? void 0 : _b.href) || null;
    return [templateData, templateCss, templateId, templateDatabaseId];
}
export function getElementorPage(layout) {
    const layoutParts = Object.keys(layout || {});
    return layoutParts === null || layoutParts === void 0 ? void 0 : layoutParts.reduce((agr, partName) => {
        const [data, css, id, databaseId] = getElementorTemplateProps(layout[partName]);
        if (!id)
            return agr;
        return Object.assign(Object.assign({}, agr), { [partName]: { data, css, id, databaseId } });
    }, { body: null, header: null, footer: null, template: null });
}
